<template>
	<div class="expert" id="expert" >
		<section class="expert-top">
			<a class="bw-logo" href="http://www.cosmopolitan.com.tw/" target="_blank"><img src="../assets/images/bw-logo.png" alt=""></a>
			<img v-if="screenWidth>1200" src="../assets/images/d-expert-title.png" alt="">
			<img v-else src="../assets/images/m-expert-title.png" alt="">
		</section>
		
		<section class="expert-product-container">
			<div class="export-content">
				
				<div class="expert-pd-item" v-for="(product,index) in expertData" :key="product.id" v-on:click="toggleModalFlag(index)" data-toggle="modal" data-target="#Modal">
					<div class="expert-pd-item-name" >
						<p class="expert-pd-class-chi">{{ allProcuctClass[index+1].chiName }}</p>
						<p class="expert-pd-class-eng">{{ allProcuctClass[index+1].engName }}</p>	
					</div>
					<div class="expert-pd-pic" v-bind:style="{backgroundImage: 'url(' + setImageUrlModal(product.image) + ')'}">
						<div class="pd-cover">
							<h4 class="pd-brand">{{product.brand}}</h4>
							<p>{{product.product}}</p>
							<div class="pd-detail">
								產品說明
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section v-if="screenWidth>1200" class="expert-list">
			<!-- <img v-on:click="pagetoVote()" src="../assets/images/d-expert-banner.png" alt="" class="banner"> -->
			<img src="../assets/images/d-expert-list.png" alt="" class="expert-list-pic">
		</section>
		<section v-else class="expert-list">
			<!-- <img v-on:click="pagetoVote()" src="../assets/images/m-expert-banner.png" alt="" class="banner"> -->
			<img src="../assets/images/m-expert-list.png" alt="" class="expert-list-pic">
		</section>

		<section class="expert-video">
			<div v-if="screenWidth>1200" class="expert-video-title">
				<img src="../assets/images/expert-video-title.png" alt="">
			</div>
			<div v-else class="expert-video-title">
				<img src="../assets/images/expert-video-title-m.png" alt="">
			</div>
			<video id="videomp4" controls>
				<source src="http://event.cosmopolitan.com.tw/2017/beautyawards/images/cosmo-expert2017.mp4" type="video/mp4">
			</video>
		</section>
		

		<Modal :modalShownSon="modalShown" :votePageShowPd="expertData[pdIndex]" :imgUrl="cosmoUrl" :sendPage="'expert'" :showExpert="currentExpert[pdIndex+1]" ></Modal>
	</div>
</template>

<script>
import Modal from '../components/Modal'
import axios from 'axios'
var VueScrollTo = require('vue-scrollto')
export default{
	name: 'expert',
	data(){
		return {
			currentExpert: {},
			expertData: [],
			modalShown: false,
			pdIndex: Number
		}
	},
	components:{
		Modal
	},
	props:{
		cosmoUrl: String,
		allProductData: {},
		allProcuctClass: {},
		screenWidth: Number,
	},
	watch:{
		allProductData(val){
			let self = this 
			self.allProductData = val 
			// console.log("getAllPd-----")
			self.getExpertData()
	 	 },
		modalShownSon(value){
			let self = this 
			self.modalFlag = value
			//console.log("modal:"+self.modalFlag)
			
		},
		pdIdShow(value){
			let self = this
			//console.log("modal-pd-id:"+self.pdIdShow)
			this.changeShowProduct(self.pdIdShow)
		}
 	 },
	created (){
		//console.log("expert")

		let self = this 
		self.getExpertData()
	},
	mounted(){

    	let scroll_e = VueScrollTo.scrollTo('.expert')
	},
	destroyed () {
		
	 },
	 methods:{
		 pagetoVote: function(){
			 this.$router.push({path: '/vote/tovote'})
		 },
		 setImageUrlModal: function(productImage){
				let self = this 
				return self.cosmoUrl+'images/'+productImage
		},
		 toggleModalFlag: function(index){
			let self = this
			self.pdIndex = index
			self.modalShown = !self.modalShown
			// console.log("toggleModalFlag:"+self.pdIndex)
		},
		getExpertData: function(){
			let self = this
			// console.log("expert------")
			axios.get(self.cosmoUrl+'route.php?r=expert')
			.then((resp)=>{
				self.currentExpert = resp.data
				// console.log(self.currentExpert)
				let obj = self.allProductData
				let ids = self.currentExpert
			
				Object.keys(ids).forEach((key)=>{      
					self.expertData.push(obj[key][ids[key].id])   
				})      
				
			})
			.catch((err) => {
				console.log(err)
			})
		}
	 }
}
</script>

<style lang="sass" scoped>
@mixin rwd($w)
	@media only screen and (max-width: $w) 
		@content
$main-color: #f21290
.expert
	background-image: url(../assets/images/d-bg.jpg)
	background-position: 50% 0
	background-size: cover
	background-repeat: no-repeat
	background-attachment: fixed
	padding-bottom: 100px
.expert-top 
	width: 100%
	height: 600px
	position: relative
	// overflow: hidden
	padding-top: 21px
	// background-color: #000
	z-index: 1
	padding-top: 64px
	
	img 
		margin: 0 auto
	&:after
		content: ''
		position: absolute
		z-index: -1
		top: 0
		left: calc(50% - 1280px)
		height: 684px
		width: 2560px
		background-image: url(../assets/images/d-page-kv.png)
		background-position: 50% 0
		background-size: cover
		background-repeat: no-repeat
	// &:before
	// 	content: ''
	// 	position: absolute
	// 	left: 0
	// 	bottom: -600px
	// 	width: 100%
	// 	height: 600px
	// 	background: linear-gradient(180deg, rgba(0, 0, 0, 1)0%, rgba(255, 255, 255, 0)33%) 
	// 	background: -moz-linear-gradient(180deg, rgba(0, 0, 0, 1)0%, rgba(255, 255, 255, 0)33%) 
	// 	background: -webkit-linear-gradient(180deg, rgba(0, 0, 0, 1)0%, rgba(255, 255, 255, 0)33%) 
	// 	background: -o-linear-gradient(180deg, rgba(0, 0, 0, 1)0%, rgba(255, 255, 255, 0)33%) 
	.bw-logo
		height: 54px
		position: absolute
		top: 21px
		left: calc(50% - 600px)
		img 
			height: 100%
.expert-product-container
	width: 100%
	// height: 800px
	margin-top: -340px
	z-index: 5
	position: relative
	>.export-content
		display: flex
		flex-direction: row
		justify-content: center
		flex-wrap: wrap
		width: 1240px
		margin: 0 auto
		.expert-pd-item-name
				width: 100%
				height: 58px
				color: #ffffff
				text-align: center
				position: relative
				background-image: url(../assets/images/expert-title-img.png)
				background-position: 50% 50%
				background-size: contain
				background-repeat: no-repeat
				padding-top: 5px
				>.expert-pd-class-eng
					font-size: 14px
					font-weight: 300
					line-height: 1.43
					
				>.expert-pd-class-chi 
					font-size: 22px
					font-weight: bold
					line-height: 0.91
		
		.expert-pd-item
			margin: 0 6px 20px 6px
			$pd-size: 296px
			width: $pd-size
			height: 366px
			cursor: pointer
			&:hover 
				.pd-cover 
					opacity: 1
					visibility: visible
			.pd-cover 
				width: 100%
				height: 100%
				background-image: url('../assets/images/pd-cover.png')
				background-position: 50% 50%
				background-size: cover
				position: absolute
				top: 0
				left: 0
				opacity: 0
				visibility: hidden
				transition: opacity .35s, visibility .35s, height .35s
				z-index: 3
				padding: 74px 5% 0
			
			>.expert-pd-pic
				width: 100%
				position: relative
				height: $pd-size
				background-color: #dedede
				background-position: 50% 50%
				background-size: cover
				background-repeat: no-repeat
				
				.pd-brand,
				p,
				.pd-detail
					font-size: 18px
					font-weight: 500
					line-height: 1.55
					text-align: center
					color: #ffffff
					line-height: 1.56
					text-shadow: 0px 0px 12px #222
				.pd-detail
					background-color: $main-color
					width: 120px
					height: 35px
					line-height: 35px
					margin: 0 auto
					margin-top: 60px

.expert-list
	padding-top: 55px
	z-index: 5
	position: relative
	img 
		margin: 0 auto		
	.banner
		margin-bottom: 45px	
		cursor: pointer
.expert-video
	margin-top: 10%
	margin-bottom: 10%
	img 
		margin: 0 auto 
		margin-bottom: 30px
	video 
		width: 800px
		margin: 0 auto
		display: block
+rwd(1200px)
	.expert-top 
		width: 100%		
		background: none
		padding-top: 144px
		height: auto
		padding-bottom: 63px
		&:after 
			height: 775px
			width: 100%
			left: 0
			top: 0
			background-image: url(../assets/images/m-page-kv-n.png)
			background-position: 0% 0	
			background-size: 100%
			background-color: transparent
			background-repeat: no-repeat
		.bw-logo 
			height: auto 
			left: 35px
	.expert-product-container 
		margin-top: 0 
		padding: 0 6%
		>.export-content
			flex-direction: column
			align-items: center
			width: 100%
			.expert-pd-item-name
				height: 96px
				margin-bottom: 14px
				>.expert-pd-class-chi
					font-size: 50px
					font-weight: 400
					line-height: 1
					letter-spacing: 2.5px
				>.expert-pd-class-eng 
					font-size: 32px
					font-weight: 300
					line-height: 1.22
			.expert-pd-item
				width: 650px
				height: (650px + 96px + 14px)
				margin: 0 auto
				margin-bottom: 62px
				.pd-cover
					background-image: url(../assets/images/m-expert-pd-border.png)
					opacity: 1
					visibility: visible
					background-size: 100%
					padding: 5%
					display: flex
					flex-direction: column
					align-items: flex-start
					justify-content: flex-end
					.pd-brand,
					p 
						font-size: 36px 
						font-weight: 500
						line-height: 1.28
						text-align-last: left
				>.expert-pd-pic
					height: 650px
					.pd-detail
						display: none
	.expert-video
		video 
			width: 100%
		
</style>



// WEBPACK FOOTER //
// Expert.vue?336522cf